import React, { Component } from 'react';
import { APP_CONST } from '../../../../../../constants';
import { GeckoFields, GeckoBtn, Spinner } from '../../../../../../components';
import './style.css';

export class ConfirmCode extends Component {
    state= {
        mfaCode: '',
        showManualEntry: false,
    }

    renderQr() {
        if (this.props.qrUrl) {
            return (
                <img src={this.props.qrUrl} width="200" height="200"/>
            )
        }

        return (
            <div style={{width: 200, height: 200,}} className="d-flex flex-row justify-content-center align-items-center"><Spinner /> </div>
        );
    }

    renderConfirmationField() {

        return (
            <div className="mfaConfirmationFieldContainer">
                <GeckoFields 
                    fields={this.fields()}
                    values={this.state}
                    handler={this.handleChange.bind(this)}
                    submitHandler={() => {}} 
                />

                <GeckoBtn 
                    name={'Verify'}
                    icon={'check'}
                    type={APP_CONST.BTN_TYPE_PRIMARY}
                    className={'float-right confirmMfaButton'}
                    handler={() => this.props.confirmCode(this.state.mfaCode)}
                />
            </div>
        );
    }

    handleChange(name, evt) {
        this.setState({[name]: evt});
    }

    fields()
    {
        return [{
            label: 'MFA Code',
            key: 'mfaCode',
            width: '100%',
            disabledWhen: () => false,
            type: APP_CONST.FIELD_TYPE_TEXT,
        }];
    }

    revealSecretCode() {
        this.setState({
            showManualEntry: true,
        })
    }

    renderManualEntryCode(visible = false, code) {
        if (!code) {
            return null;
        }

        if (!visible) {
            return (
                <div className="manual2faInstructions">
                    <a id="triggerManualEntry" onClick={() => this.revealSecretCode()}>Or enter secret code manually</a>
                </div>
            )
        }

        return (
            <div className="manual2faInstructions">
                Manually enter secret code: <span className="secretCode">{code}</span>
            </div>
        )
    }

    render() {
        return (
            <div>
                <div className="qrCodeContainer">
                    <div className="row">
                        <div className="col">
                            1. Launch your Authenticator app and scan the QR code
                        </div>
                    </div>

                    <div className="row">
                        <div className="col d-flex justify-content-center">
                            {this.renderQr()}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col d-flex justify-content-center">
                            {this.renderManualEntryCode(this.state.showManualEntry, this.props.secretCode)}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            2. Confirm it works by entering the number from your authenticator app
                        </div>
                    </div>
                </div>

                {this.renderConfirmationField()}
            </div>
        )
    }

}

ConfirmCode.defaultProps = {
    qrUrl: null,
    secretCode: null,
    confirmCode: () => null,
}

export default ConfirmCode;